export function generateCode(
  length: number = 3,
  digitRange: [number, number] = [0, 9],
  allowDuplicates: boolean = false,
  avoidRuns: boolean = true,
  maxAttempts: number = 1000,
): number[] | null {
  const digits: number[] = [];
  for (let d = digitRange[0]; d <= digitRange[1]; d++) {
    digits.push(d);
  }

  if (!allowDuplicates && length > digits.length) {
    return null;
  }

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    let code: number[];

    if (allowDuplicates) {
      code = [];
      for (let i = 0; i < length; i++) {
        code.push(digits[Math.floor(Math.random() * digits.length)]);
      }
    } else {
      const available = [...digits];
      code = [];
      for (let i = 0; i < length; i++) {
        const idx = Math.floor(Math.random() * available.length);
        code.push(available.splice(idx, 1)[0]);
      }
    }

    if (avoidRuns && length >= 3) {
      let hasRun = false;
      for (let i = 0; i <= length - 3; i++) {
        if (
          code[i + 1] - code[i] === code[i + 2] - code[i + 1] &&
          Math.abs(code[i + 1] - code[i]) === 1
        ) {
          hasRun = true;
          break;
        }
      }
      if (hasRun) {
        continue;
      }
    }

    return code;
  }

  return null;
}
